import BaseApi from '../BaseApi';
class PromoApi extends BaseApi {
    constructor(baseUrl) {
        super(baseUrl);
        this.baseUrl = `api/common`;
      }

  getPromoList = (token) => this.sendQuery(
    this.queryTypes.GET,
    `${this.baseUrl}/get_promo?token=${token}`,
  )
};

export default PromoApi;

